/* istanbul ignore file */
import Badge from '../../mui-builder/Badge/Badge';
import { BadgeLayoutProps } from 'framework/ui/uiContract/uiContract';

const ExpiredBadge = (props: BadgeLayoutProps) => {
  return (
    <Badge color="default" sx={{ ml: 1 }} {...props}>
      Expired
    </Badge>
  );
};

export default ExpiredBadge;
